// src/services/theSeer.js
// The Seer — AI social media content generation for Hermod's Path

const FUNCTION_URL = process.env.NODE_ENV === 'production'
  ? 'https://us-central1-heimdl.cloudfunctions.net/generateSocialPosts'
  : 'http://localhost:5001/heimdl/us-central1/generateSocialPosts';

/**
 * Generate platform-tailored social media posts from raw content
 * @param {Object} params
 * @param {string} params.rawText - Raw bullet points / notes
 * @param {string} params.contentType - Content type (e.g. 'Mini-Museum', 'General')
 * @param {string[]} params.platforms - Selected platform IDs ('professional-ig', 'lux-libris-ig', 'linkedin', 'professional-fb', 'lux-libris-fb')
 * @param {string[]} [params.imageDescriptions] - Optional descriptions of uploaded images
 * @returns {Promise<{professionalIG: {text: string, imageNote: string, imageType: string}|null, luxLibrisIG: {text: string, imageNote: string, imageType: string}|null, linkedin: {text: string, imageNote: string, imageType: string}|null, professionalFB: {text: string, imageNote: string, imageType: string}|null, luxLibrisFB: {text: string, imageNote: string, imageType: string}|null}>}
 */
export async function generatePosts({ rawText, contentType, platforms, imageDescriptions }) {
  const response = await fetch(FUNCTION_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      rawText,
      contentType,
      platforms,
      imageDescriptions: imageDescriptions || [],
    }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `The Seer returned an error (${response.status})`);
  }

  const data = await response.json();

  if (!data.success || !data.posts) {
    throw new Error('The Seer returned an unexpected response');
  }

  return data.posts;
}
